/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CouponCode,
  Courier,
  CourierSettings,
  MailOption,
  NewCouponCode,
  NewPushSubscription,
  NewRewardsAccount,
  NewStoreLocation,
  PushSubscription,
  RewardSettings,
  RewardsAccount,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
  StoreLocation,
  ThemeSetting,
} from '../models/index';
import {
    CouponCodeFromJSON,
    CouponCodeToJSON,
    CourierFromJSON,
    CourierToJSON,
    CourierSettingsFromJSON,
    CourierSettingsToJSON,
    MailOptionFromJSON,
    MailOptionToJSON,
    NewCouponCodeFromJSON,
    NewCouponCodeToJSON,
    NewPushSubscriptionFromJSON,
    NewPushSubscriptionToJSON,
    NewRewardsAccountFromJSON,
    NewRewardsAccountToJSON,
    NewStoreLocationFromJSON,
    NewStoreLocationToJSON,
    PushSubscriptionFromJSON,
    PushSubscriptionToJSON,
    RewardSettingsFromJSON,
    RewardSettingsToJSON,
    RewardsAccountFromJSON,
    RewardsAccountToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
    StoreLocationFromJSON,
    StoreLocationToJSON,
    ThemeSettingFromJSON,
    ThemeSettingToJSON,
} from '../models/index';

export interface StoreLocationCountRequest {
    where?: string;
}

export interface StoreLocationCreateRequest {
    data?: NewStoreLocation;
}

export interface StoreLocationCreateChangeStreamGetStoreLocationsChangeStreamRequest {
    options?: string;
}

export interface StoreLocationCreateChangeStreamPostStoreLocationsChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface StoreLocationDeleteByIdRequest {
    id: string;
}

export interface StoreLocationExistsGetStoreLocationsidExistsRequest {
    id: string;
}

export interface StoreLocationExistsHeadStoreLocationsidRequest {
    id: string;
}

export interface StoreLocationFindRequest {
    filter?: string;
}

export interface StoreLocationFindByIdRequest {
    id: string;
    filter?: string;
}

export interface StoreLocationFindOneRequest {
    filter?: string;
}

export interface StoreLocationPatchOrCreateRequest {
    data?: StoreLocation;
}

export interface StoreLocationPrototypeCountCourierCouponCodesRequest {
    id: string;
    where?: string;
}

export interface StoreLocationPrototypeCountCourierPushSubscribersRequest {
    id: string;
    where?: string;
}

export interface StoreLocationPrototypeCountCourierRewardsAccountsRequest {
    id: string;
    where?: string;
}

export interface StoreLocationPrototypeCountCourierStoreLocationsRequest {
    id: string;
    where?: string;
}

export interface StoreLocationPrototypeCreateCourierCouponCodesRequest {
    id: string;
    data?: NewCouponCode;
}

export interface StoreLocationPrototypeCreateCourierCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface StoreLocationPrototypeCreateCourierMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface StoreLocationPrototypeCreateCourierPushSubscribersRequest {
    id: string;
    data?: NewPushSubscription;
}

export interface StoreLocationPrototypeCreateCourierRewardSettingRequest {
    id: string;
    data?: RewardSettings;
}

export interface StoreLocationPrototypeCreateCourierRewardsAccountsRequest {
    id: string;
    data?: NewRewardsAccount;
}

export interface StoreLocationPrototypeCreateCourierStoreLocationsRequest {
    id: string;
    data?: NewStoreLocation;
}

export interface StoreLocationPrototypeCreateCourierThemeSettingRequest {
    id: string;
    data?: ThemeSetting;
}

export interface StoreLocationPrototypeDeleteCourierCouponCodesRequest {
    id: string;
}

export interface StoreLocationPrototypeDeleteCourierPushSubscribersRequest {
    id: string;
}

export interface StoreLocationPrototypeDeleteCourierRewardsAccountsRequest {
    id: string;
}

export interface StoreLocationPrototypeDeleteCourierStoreLocationsRequest {
    id: string;
}

export interface StoreLocationPrototypeDestroyByIdCourierCouponCodesRequest {
    id: string;
    fk: string;
}

export interface StoreLocationPrototypeDestroyByIdCourierPushSubscribersRequest {
    id: string;
    fk: string;
}

export interface StoreLocationPrototypeDestroyByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
}

export interface StoreLocationPrototypeDestroyByIdCourierStoreLocationsRequest {
    id: string;
    fk: string;
}

export interface StoreLocationPrototypeDestroyCourierCourierSettingRequest {
    id: string;
}

export interface StoreLocationPrototypeDestroyCourierMailOptionRequest {
    id: string;
}

export interface StoreLocationPrototypeDestroyCourierRewardSettingRequest {
    id: string;
}

export interface StoreLocationPrototypeDestroyCourierThemeSettingRequest {
    id: string;
}

export interface StoreLocationPrototypeFindByIdCourierCouponCodesRequest {
    id: string;
    fk: string;
}

export interface StoreLocationPrototypeFindByIdCourierPushSubscribersRequest {
    id: string;
    fk: string;
}

export interface StoreLocationPrototypeFindByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
}

export interface StoreLocationPrototypeFindByIdCourierStoreLocationsRequest {
    id: string;
    fk: string;
}

export interface StoreLocationPrototypeGetCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface StoreLocationPrototypeGetCourierCouponCodesRequest {
    id: string;
    filter?: string;
}

export interface StoreLocationPrototypeGetCourierCourierSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface StoreLocationPrototypeGetCourierMailOptionRequest {
    id: string;
    refresh?: boolean;
}

export interface StoreLocationPrototypeGetCourierPushSubscribersRequest {
    id: string;
    filter?: string;
}

export interface StoreLocationPrototypeGetCourierRewardSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface StoreLocationPrototypeGetCourierRewardsAccountsRequest {
    id: string;
    filter?: string;
}

export interface StoreLocationPrototypeGetCourierStoreLocationsRequest {
    id: string;
    filter?: string;
}

export interface StoreLocationPrototypeGetCourierThemeSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface StoreLocationPrototypePatchAttributesRequest {
    id: string;
    data?: StoreLocation;
}

export interface StoreLocationPrototypeUpdateByIdCourierCouponCodesRequest {
    id: string;
    fk: string;
    data?: CouponCode;
}

export interface StoreLocationPrototypeUpdateByIdCourierPushSubscribersRequest {
    id: string;
    fk: string;
    data?: PushSubscription;
}

export interface StoreLocationPrototypeUpdateByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
    data?: RewardsAccount;
}

export interface StoreLocationPrototypeUpdateByIdCourierStoreLocationsRequest {
    id: string;
    fk: string;
    data?: StoreLocation;
}

export interface StoreLocationPrototypeUpdateCourierCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface StoreLocationPrototypeUpdateCourierMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface StoreLocationPrototypeUpdateCourierRewardSettingRequest {
    id: string;
    data?: RewardSettings;
}

export interface StoreLocationPrototypeUpdateCourierThemeSettingRequest {
    id: string;
    data?: ThemeSetting;
}

export interface StoreLocationReplaceByIdPostStoreLocationsidReplaceRequest {
    id: string;
    data?: StoreLocation;
}

export interface StoreLocationReplaceByIdPutStoreLocationsidRequest {
    id: string;
    data?: StoreLocation;
}

export interface StoreLocationReplaceOrCreatePostStoreLocationsReplaceOrCreateRequest {
    data?: StoreLocation;
}

export interface StoreLocationReplaceOrCreatePutStoreLocationsRequest {
    data?: StoreLocation;
}

export interface StoreLocationUpdateAllRequest {
    where?: string;
    data?: StoreLocation;
}

export interface StoreLocationUpsertWithWhereRequest {
    where?: string;
    data?: StoreLocation;
}

/**
 * 
 */
export class StoreLocationApi extends runtime.BaseAPI {

    /**
     * Count instances of the model matched by where from the data source.
     */
    async storeLocationCountRaw(requestParameters: StoreLocationCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async storeLocationCount(requestParameters: StoreLocationCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.storeLocationCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async storeLocationCreateRaw(requestParameters: StoreLocationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewStoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async storeLocationCreate(requestParameters: StoreLocationCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.storeLocationCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async storeLocationCreateChangeStreamGetStoreLocationsChangeStreamRaw(requestParameters: StoreLocationCreateChangeStreamGetStoreLocationsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['options'] != null) {
            queryParameters['options'] = requestParameters['options'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async storeLocationCreateChangeStreamGetStoreLocationsChangeStream(requestParameters: StoreLocationCreateChangeStreamGetStoreLocationsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.storeLocationCreateChangeStreamGetStoreLocationsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async storeLocationCreateChangeStreamPostStoreLocationsChangeStreamRaw(requestParameters: StoreLocationCreateChangeStreamPostStoreLocationsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async storeLocationCreateChangeStreamPostStoreLocationsChangeStream(requestParameters: StoreLocationCreateChangeStreamPostStoreLocationsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.storeLocationCreateChangeStreamPostStoreLocationsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async storeLocationDeleteByIdRaw(requestParameters: StoreLocationDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async storeLocationDeleteById(requestParameters: StoreLocationDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.storeLocationDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async storeLocationExistsGetStoreLocationsidExistsRaw(requestParameters: StoreLocationExistsGetStoreLocationsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationExistsGetStoreLocationsidExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async storeLocationExistsGetStoreLocationsidExists(requestParameters: StoreLocationExistsGetStoreLocationsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.storeLocationExistsGetStoreLocationsidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async storeLocationExistsHeadStoreLocationsidRaw(requestParameters: StoreLocationExistsHeadStoreLocationsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationExistsHeadStoreLocationsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async storeLocationExistsHeadStoreLocationsid(requestParameters: StoreLocationExistsHeadStoreLocationsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.storeLocationExistsHeadStoreLocationsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async storeLocationFindRaw(requestParameters: StoreLocationFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StoreLocation>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StoreLocationFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async storeLocationFind(requestParameters: StoreLocationFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StoreLocation>> {
        const response = await this.storeLocationFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async storeLocationFindByIdRaw(requestParameters: StoreLocationFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async storeLocationFindById(requestParameters: StoreLocationFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.storeLocationFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async storeLocationFindOneRaw(requestParameters: StoreLocationFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async storeLocationFindOne(requestParameters: StoreLocationFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.storeLocationFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async storeLocationPatchOrCreateRaw(requestParameters: StoreLocationPatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async storeLocationPatchOrCreate(requestParameters: StoreLocationPatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.storeLocationPatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts couponCodes of Courier.
     */
    async storeLocationPrototypeCountCourierCouponCodesRaw(requestParameters: StoreLocationPrototypeCountCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeCountCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/couponCodes/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts couponCodes of Courier.
     */
    async storeLocationPrototypeCountCourierCouponCodes(requestParameters: StoreLocationPrototypeCountCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.storeLocationPrototypeCountCourierCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts pushSubscribers of Courier.
     */
    async storeLocationPrototypeCountCourierPushSubscribersRaw(requestParameters: StoreLocationPrototypeCountCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeCountCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/pushSubscribers/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts pushSubscribers of Courier.
     */
    async storeLocationPrototypeCountCourierPushSubscribers(requestParameters: StoreLocationPrototypeCountCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.storeLocationPrototypeCountCourierPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts rewardsAccounts of Courier.
     */
    async storeLocationPrototypeCountCourierRewardsAccountsRaw(requestParameters: StoreLocationPrototypeCountCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeCountCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/rewardsAccounts/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts rewardsAccounts of Courier.
     */
    async storeLocationPrototypeCountCourierRewardsAccounts(requestParameters: StoreLocationPrototypeCountCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.storeLocationPrototypeCountCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts storeLocations of Courier.
     */
    async storeLocationPrototypeCountCourierStoreLocationsRaw(requestParameters: StoreLocationPrototypeCountCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeCountCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/storeLocations/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts storeLocations of Courier.
     */
    async storeLocationPrototypeCountCourierStoreLocations(requestParameters: StoreLocationPrototypeCountCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.storeLocationPrototypeCountCourierStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in couponCodes of this model.
     */
    async storeLocationPrototypeCreateCourierCouponCodesRaw(requestParameters: StoreLocationPrototypeCreateCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponCode>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeCreateCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/couponCodes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCouponCodeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponCodeFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in couponCodes of this model.
     */
    async storeLocationPrototypeCreateCourierCouponCodes(requestParameters: StoreLocationPrototypeCreateCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponCode> {
        const response = await this.storeLocationPrototypeCreateCourierCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async storeLocationPrototypeCreateCourierCourierSettingRaw(requestParameters: StoreLocationPrototypeCreateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeCreateCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async storeLocationPrototypeCreateCourierCourierSetting(requestParameters: StoreLocationPrototypeCreateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.storeLocationPrototypeCreateCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async storeLocationPrototypeCreateCourierMailOptionRaw(requestParameters: StoreLocationPrototypeCreateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeCreateCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async storeLocationPrototypeCreateCourierMailOption(requestParameters: StoreLocationPrototypeCreateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.storeLocationPrototypeCreateCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in pushSubscribers of this model.
     */
    async storeLocationPrototypeCreateCourierPushSubscribersRaw(requestParameters: StoreLocationPrototypeCreateCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushSubscription>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeCreateCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/pushSubscribers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewPushSubscriptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PushSubscriptionFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in pushSubscribers of this model.
     */
    async storeLocationPrototypeCreateCourierPushSubscribers(requestParameters: StoreLocationPrototypeCreateCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushSubscription> {
        const response = await this.storeLocationPrototypeCreateCourierPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in rewardSetting of this model.
     */
    async storeLocationPrototypeCreateCourierRewardSettingRaw(requestParameters: StoreLocationPrototypeCreateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeCreateCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in rewardSetting of this model.
     */
    async storeLocationPrototypeCreateCourierRewardSetting(requestParameters: StoreLocationPrototypeCreateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.storeLocationPrototypeCreateCourierRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in rewardsAccounts of this model.
     */
    async storeLocationPrototypeCreateCourierRewardsAccountsRaw(requestParameters: StoreLocationPrototypeCreateCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeCreateCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in rewardsAccounts of this model.
     */
    async storeLocationPrototypeCreateCourierRewardsAccounts(requestParameters: StoreLocationPrototypeCreateCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.storeLocationPrototypeCreateCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in storeLocations of this model.
     */
    async storeLocationPrototypeCreateCourierStoreLocationsRaw(requestParameters: StoreLocationPrototypeCreateCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeCreateCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/storeLocations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewStoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in storeLocations of this model.
     */
    async storeLocationPrototypeCreateCourierStoreLocations(requestParameters: StoreLocationPrototypeCreateCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.storeLocationPrototypeCreateCourierStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in themeSetting of this model.
     */
    async storeLocationPrototypeCreateCourierThemeSettingRaw(requestParameters: StoreLocationPrototypeCreateCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeCreateCourierThemeSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/themeSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in themeSetting of this model.
     */
    async storeLocationPrototypeCreateCourierThemeSetting(requestParameters: StoreLocationPrototypeCreateCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.storeLocationPrototypeCreateCourierThemeSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes all couponCodes of this model.
     */
    async storeLocationPrototypeDeleteCourierCouponCodesRaw(requestParameters: StoreLocationPrototypeDeleteCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeDeleteCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/couponCodes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all couponCodes of this model.
     */
    async storeLocationPrototypeDeleteCourierCouponCodes(requestParameters: StoreLocationPrototypeDeleteCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeLocationPrototypeDeleteCourierCouponCodesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all pushSubscribers of this model.
     */
    async storeLocationPrototypeDeleteCourierPushSubscribersRaw(requestParameters: StoreLocationPrototypeDeleteCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeDeleteCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/pushSubscribers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all pushSubscribers of this model.
     */
    async storeLocationPrototypeDeleteCourierPushSubscribers(requestParameters: StoreLocationPrototypeDeleteCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeLocationPrototypeDeleteCourierPushSubscribersRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all rewardsAccounts of this model.
     */
    async storeLocationPrototypeDeleteCourierRewardsAccountsRaw(requestParameters: StoreLocationPrototypeDeleteCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeDeleteCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all rewardsAccounts of this model.
     */
    async storeLocationPrototypeDeleteCourierRewardsAccounts(requestParameters: StoreLocationPrototypeDeleteCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeLocationPrototypeDeleteCourierRewardsAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all storeLocations of this model.
     */
    async storeLocationPrototypeDeleteCourierStoreLocationsRaw(requestParameters: StoreLocationPrototypeDeleteCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeDeleteCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/storeLocations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all storeLocations of this model.
     */
    async storeLocationPrototypeDeleteCourierStoreLocations(requestParameters: StoreLocationPrototypeDeleteCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeLocationPrototypeDeleteCourierStoreLocationsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for couponCodes.
     */
    async storeLocationPrototypeDestroyByIdCourierCouponCodesRaw(requestParameters: StoreLocationPrototypeDestroyByIdCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeDestroyByIdCourierCouponCodes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling storeLocationPrototypeDestroyByIdCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/couponCodes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for couponCodes.
     */
    async storeLocationPrototypeDestroyByIdCourierCouponCodes(requestParameters: StoreLocationPrototypeDestroyByIdCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeLocationPrototypeDestroyByIdCourierCouponCodesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for pushSubscribers.
     */
    async storeLocationPrototypeDestroyByIdCourierPushSubscribersRaw(requestParameters: StoreLocationPrototypeDestroyByIdCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeDestroyByIdCourierPushSubscribers().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling storeLocationPrototypeDestroyByIdCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/pushSubscribers/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for pushSubscribers.
     */
    async storeLocationPrototypeDestroyByIdCourierPushSubscribers(requestParameters: StoreLocationPrototypeDestroyByIdCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeLocationPrototypeDestroyByIdCourierPushSubscribersRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for rewardsAccounts.
     */
    async storeLocationPrototypeDestroyByIdCourierRewardsAccountsRaw(requestParameters: StoreLocationPrototypeDestroyByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeDestroyByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling storeLocationPrototypeDestroyByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for rewardsAccounts.
     */
    async storeLocationPrototypeDestroyByIdCourierRewardsAccounts(requestParameters: StoreLocationPrototypeDestroyByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeLocationPrototypeDestroyByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for storeLocations.
     */
    async storeLocationPrototypeDestroyByIdCourierStoreLocationsRaw(requestParameters: StoreLocationPrototypeDestroyByIdCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeDestroyByIdCourierStoreLocations().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling storeLocationPrototypeDestroyByIdCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/storeLocations/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for storeLocations.
     */
    async storeLocationPrototypeDestroyByIdCourierStoreLocations(requestParameters: StoreLocationPrototypeDestroyByIdCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeLocationPrototypeDestroyByIdCourierStoreLocationsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async storeLocationPrototypeDestroyCourierCourierSettingRaw(requestParameters: StoreLocationPrototypeDestroyCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeDestroyCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async storeLocationPrototypeDestroyCourierCourierSetting(requestParameters: StoreLocationPrototypeDestroyCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeLocationPrototypeDestroyCourierCourierSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes mailOption of this model.
     */
    async storeLocationPrototypeDestroyCourierMailOptionRaw(requestParameters: StoreLocationPrototypeDestroyCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeDestroyCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes mailOption of this model.
     */
    async storeLocationPrototypeDestroyCourierMailOption(requestParameters: StoreLocationPrototypeDestroyCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeLocationPrototypeDestroyCourierMailOptionRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes rewardSetting of this model.
     */
    async storeLocationPrototypeDestroyCourierRewardSettingRaw(requestParameters: StoreLocationPrototypeDestroyCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeDestroyCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes rewardSetting of this model.
     */
    async storeLocationPrototypeDestroyCourierRewardSetting(requestParameters: StoreLocationPrototypeDestroyCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeLocationPrototypeDestroyCourierRewardSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes themeSetting of this model.
     */
    async storeLocationPrototypeDestroyCourierThemeSettingRaw(requestParameters: StoreLocationPrototypeDestroyCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeDestroyCourierThemeSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/themeSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes themeSetting of this model.
     */
    async storeLocationPrototypeDestroyCourierThemeSetting(requestParameters: StoreLocationPrototypeDestroyCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeLocationPrototypeDestroyCourierThemeSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Find a related item by id for couponCodes.
     */
    async storeLocationPrototypeFindByIdCourierCouponCodesRaw(requestParameters: StoreLocationPrototypeFindByIdCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponCode>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeFindByIdCourierCouponCodes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling storeLocationPrototypeFindByIdCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/couponCodes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponCodeFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for couponCodes.
     */
    async storeLocationPrototypeFindByIdCourierCouponCodes(requestParameters: StoreLocationPrototypeFindByIdCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponCode> {
        const response = await this.storeLocationPrototypeFindByIdCourierCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for pushSubscribers.
     */
    async storeLocationPrototypeFindByIdCourierPushSubscribersRaw(requestParameters: StoreLocationPrototypeFindByIdCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushSubscription>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeFindByIdCourierPushSubscribers().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling storeLocationPrototypeFindByIdCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/pushSubscribers/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PushSubscriptionFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for pushSubscribers.
     */
    async storeLocationPrototypeFindByIdCourierPushSubscribers(requestParameters: StoreLocationPrototypeFindByIdCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushSubscription> {
        const response = await this.storeLocationPrototypeFindByIdCourierPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for rewardsAccounts.
     */
    async storeLocationPrototypeFindByIdCourierRewardsAccountsRaw(requestParameters: StoreLocationPrototypeFindByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeFindByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling storeLocationPrototypeFindByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for rewardsAccounts.
     */
    async storeLocationPrototypeFindByIdCourierRewardsAccounts(requestParameters: StoreLocationPrototypeFindByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.storeLocationPrototypeFindByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for storeLocations.
     */
    async storeLocationPrototypeFindByIdCourierStoreLocationsRaw(requestParameters: StoreLocationPrototypeFindByIdCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeFindByIdCourierStoreLocations().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling storeLocationPrototypeFindByIdCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/storeLocations/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for storeLocations.
     */
    async storeLocationPrototypeFindByIdCourierStoreLocations(requestParameters: StoreLocationPrototypeFindByIdCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.storeLocationPrototypeFindByIdCourierStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async storeLocationPrototypeGetCourierRaw(requestParameters: StoreLocationPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeGetCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async storeLocationPrototypeGetCourier(requestParameters: StoreLocationPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.storeLocationPrototypeGetCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries couponCodes of Courier.
     */
    async storeLocationPrototypeGetCourierCouponCodesRaw(requestParameters: StoreLocationPrototypeGetCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CouponCode>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeGetCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/couponCodes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CouponCodeFromJSON));
    }

    /**
     * Queries couponCodes of Courier.
     */
    async storeLocationPrototypeGetCourierCouponCodes(requestParameters: StoreLocationPrototypeGetCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CouponCode>> {
        const response = await this.storeLocationPrototypeGetCourierCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async storeLocationPrototypeGetCourierCourierSettingRaw(requestParameters: StoreLocationPrototypeGetCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeGetCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async storeLocationPrototypeGetCourierCourierSetting(requestParameters: StoreLocationPrototypeGetCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.storeLocationPrototypeGetCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async storeLocationPrototypeGetCourierMailOptionRaw(requestParameters: StoreLocationPrototypeGetCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeGetCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async storeLocationPrototypeGetCourierMailOption(requestParameters: StoreLocationPrototypeGetCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.storeLocationPrototypeGetCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries pushSubscribers of Courier.
     */
    async storeLocationPrototypeGetCourierPushSubscribersRaw(requestParameters: StoreLocationPrototypeGetCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PushSubscription>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeGetCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/pushSubscribers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PushSubscriptionFromJSON));
    }

    /**
     * Queries pushSubscribers of Courier.
     */
    async storeLocationPrototypeGetCourierPushSubscribers(requestParameters: StoreLocationPrototypeGetCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PushSubscription>> {
        const response = await this.storeLocationPrototypeGetCourierPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation rewardSetting.
     */
    async storeLocationPrototypeGetCourierRewardSettingRaw(requestParameters: StoreLocationPrototypeGetCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeGetCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation rewardSetting.
     */
    async storeLocationPrototypeGetCourierRewardSetting(requestParameters: StoreLocationPrototypeGetCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.storeLocationPrototypeGetCourierRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries rewardsAccounts of Courier.
     */
    async storeLocationPrototypeGetCourierRewardsAccountsRaw(requestParameters: StoreLocationPrototypeGetCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RewardsAccount>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeGetCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RewardsAccountFromJSON));
    }

    /**
     * Queries rewardsAccounts of Courier.
     */
    async storeLocationPrototypeGetCourierRewardsAccounts(requestParameters: StoreLocationPrototypeGetCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RewardsAccount>> {
        const response = await this.storeLocationPrototypeGetCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries storeLocations of Courier.
     */
    async storeLocationPrototypeGetCourierStoreLocationsRaw(requestParameters: StoreLocationPrototypeGetCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StoreLocation>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeGetCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/storeLocations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StoreLocationFromJSON));
    }

    /**
     * Queries storeLocations of Courier.
     */
    async storeLocationPrototypeGetCourierStoreLocations(requestParameters: StoreLocationPrototypeGetCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StoreLocation>> {
        const response = await this.storeLocationPrototypeGetCourierStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation themeSetting.
     */
    async storeLocationPrototypeGetCourierThemeSettingRaw(requestParameters: StoreLocationPrototypeGetCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeGetCourierThemeSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/themeSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation themeSetting.
     */
    async storeLocationPrototypeGetCourierThemeSetting(requestParameters: StoreLocationPrototypeGetCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.storeLocationPrototypeGetCourierThemeSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async storeLocationPrototypePatchAttributesRaw(requestParameters: StoreLocationPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async storeLocationPrototypePatchAttributes(requestParameters: StoreLocationPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.storeLocationPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for couponCodes.
     */
    async storeLocationPrototypeUpdateByIdCourierCouponCodesRaw(requestParameters: StoreLocationPrototypeUpdateByIdCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponCode>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeUpdateByIdCourierCouponCodes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling storeLocationPrototypeUpdateByIdCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/couponCodes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CouponCodeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponCodeFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for couponCodes.
     */
    async storeLocationPrototypeUpdateByIdCourierCouponCodes(requestParameters: StoreLocationPrototypeUpdateByIdCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponCode> {
        const response = await this.storeLocationPrototypeUpdateByIdCourierCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for pushSubscribers.
     */
    async storeLocationPrototypeUpdateByIdCourierPushSubscribersRaw(requestParameters: StoreLocationPrototypeUpdateByIdCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushSubscription>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeUpdateByIdCourierPushSubscribers().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling storeLocationPrototypeUpdateByIdCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/pushSubscribers/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PushSubscriptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PushSubscriptionFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for pushSubscribers.
     */
    async storeLocationPrototypeUpdateByIdCourierPushSubscribers(requestParameters: StoreLocationPrototypeUpdateByIdCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushSubscription> {
        const response = await this.storeLocationPrototypeUpdateByIdCourierPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for rewardsAccounts.
     */
    async storeLocationPrototypeUpdateByIdCourierRewardsAccountsRaw(requestParameters: StoreLocationPrototypeUpdateByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeUpdateByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling storeLocationPrototypeUpdateByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for rewardsAccounts.
     */
    async storeLocationPrototypeUpdateByIdCourierRewardsAccounts(requestParameters: StoreLocationPrototypeUpdateByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.storeLocationPrototypeUpdateByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for storeLocations.
     */
    async storeLocationPrototypeUpdateByIdCourierStoreLocationsRaw(requestParameters: StoreLocationPrototypeUpdateByIdCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeUpdateByIdCourierStoreLocations().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling storeLocationPrototypeUpdateByIdCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/storeLocations/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for storeLocations.
     */
    async storeLocationPrototypeUpdateByIdCourierStoreLocations(requestParameters: StoreLocationPrototypeUpdateByIdCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.storeLocationPrototypeUpdateByIdCourierStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update courierSetting of this model.
     */
    async storeLocationPrototypeUpdateCourierCourierSettingRaw(requestParameters: StoreLocationPrototypeUpdateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeUpdateCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Update courierSetting of this model.
     */
    async storeLocationPrototypeUpdateCourierCourierSetting(requestParameters: StoreLocationPrototypeUpdateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.storeLocationPrototypeUpdateCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update mailOption of this model.
     */
    async storeLocationPrototypeUpdateCourierMailOptionRaw(requestParameters: StoreLocationPrototypeUpdateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeUpdateCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Update mailOption of this model.
     */
    async storeLocationPrototypeUpdateCourierMailOption(requestParameters: StoreLocationPrototypeUpdateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.storeLocationPrototypeUpdateCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update rewardSetting of this model.
     */
    async storeLocationPrototypeUpdateCourierRewardSettingRaw(requestParameters: StoreLocationPrototypeUpdateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeUpdateCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Update rewardSetting of this model.
     */
    async storeLocationPrototypeUpdateCourierRewardSetting(requestParameters: StoreLocationPrototypeUpdateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.storeLocationPrototypeUpdateCourierRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update themeSetting of this model.
     */
    async storeLocationPrototypeUpdateCourierThemeSettingRaw(requestParameters: StoreLocationPrototypeUpdateCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationPrototypeUpdateCourierThemeSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/courier/themeSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Update themeSetting of this model.
     */
    async storeLocationPrototypeUpdateCourierThemeSetting(requestParameters: StoreLocationPrototypeUpdateCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.storeLocationPrototypeUpdateCourierThemeSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async storeLocationReplaceByIdPostStoreLocationsidReplaceRaw(requestParameters: StoreLocationReplaceByIdPostStoreLocationsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationReplaceByIdPostStoreLocationsidReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async storeLocationReplaceByIdPostStoreLocationsidReplace(requestParameters: StoreLocationReplaceByIdPostStoreLocationsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.storeLocationReplaceByIdPostStoreLocationsidReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async storeLocationReplaceByIdPutStoreLocationsidRaw(requestParameters: StoreLocationReplaceByIdPutStoreLocationsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling storeLocationReplaceByIdPutStoreLocationsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async storeLocationReplaceByIdPutStoreLocationsid(requestParameters: StoreLocationReplaceByIdPutStoreLocationsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.storeLocationReplaceByIdPutStoreLocationsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async storeLocationReplaceOrCreatePostStoreLocationsReplaceOrCreateRaw(requestParameters: StoreLocationReplaceOrCreatePostStoreLocationsReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async storeLocationReplaceOrCreatePostStoreLocationsReplaceOrCreate(requestParameters: StoreLocationReplaceOrCreatePostStoreLocationsReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.storeLocationReplaceOrCreatePostStoreLocationsReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async storeLocationReplaceOrCreatePutStoreLocationsRaw(requestParameters: StoreLocationReplaceOrCreatePutStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async storeLocationReplaceOrCreatePutStoreLocations(requestParameters: StoreLocationReplaceOrCreatePutStoreLocationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.storeLocationReplaceOrCreatePutStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async storeLocationUpdateAllRaw(requestParameters: StoreLocationUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async storeLocationUpdateAll(requestParameters: StoreLocationUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.storeLocationUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async storeLocationUpsertWithWhereRaw(requestParameters: StoreLocationUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StoreLocations/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async storeLocationUpsertWithWhere(requestParameters: StoreLocationUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.storeLocationUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
